module.exports = __webpack_public_path__ + "img/courseIntro.21182191.png";